import type { UserLicenseType } from '@bb/users';
import { isUserLicensed } from '@bb/users';

/**
 * Given the provided user information, determines if a transfer request needs to be made
 * instead of creating a new user.
 */
export const shouldRequestTransfer = ({
  primaryMemberNumberState,
  primaryNumber,
  firstNameValid,
  lastNameValid,
  isNew,
  licenseType,
}: {
  primaryMemberNumberState: any;
  primaryNumber: any;
  firstNameValid?: boolean;
  lastNameValid?: boolean;
  isNew?: boolean;
  licenseType?: UserLicenseType;
}) => {
  if (!isUserLicensed({ licenseType })) return false;
  return (
    primaryMemberNumberState?.inBrokerBay &&
    !primaryMemberNumberState.inOrg &&
    !primaryMemberNumberState.isPendingTransfer &&
    primaryNumber &&
    firstNameValid &&
    lastNameValid &&
    isNew
  );
};

export const cantRequestTransfer = ({
  branchValid,
  addressValid,
  memberNumbersAllValid,
  emailValid,
  mobileValid,
  memberNumberStateLoading,
}: {
  branchValid?: boolean;
  addressValid?: boolean;
  memberNumbersAllValid?: boolean;
  emailValid?: boolean;
  mobileValid?: boolean;
  memberNumberStateLoading?: boolean;
}) =>
  !branchValid ||
  !addressValid ||
  !memberNumbersAllValid ||
  !emailValid ||
  !mobileValid ||
  memberNumberStateLoading;
